var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('router-view'),_c('Tabbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }